import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Linkedin } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { IMAGES } from '../../constants/images';

const leadership = [
  {
    name: 'CA Abhinav Kapoor',
    role: 'Finance Vertical Head',
    image: IMAGES.abhinav,
    linkedin: 'https://www.linkedin.com/in/ca-abhinav-kapoor-aborwar-2b083755/',
    description: 'A qualified Chartered Accountant (2012) and Law Graduate from the University of Rajasthan. With nearly a decade of experience in the finance sector, including 3 years as Credit Manager at ICICI Bank, Abhinav leads SME Funding and Project Loans with deep industry expertise.'
  },
  {
    name: 'CA Aneesh Patni',
    role: 'Subsidy Vertical Head',
    image: IMAGES.aneesh,
    linkedin: 'https://www.linkedin.com/in/aneesh-patni-88aborwar/',
    description: 'A qualified Chartered Accountant (2012) and Commerce Graduate from the University of Rajasthan. With 3 years of ERP consulting experience, Aneesh successfully manages both State and Central Government Subsidy Schemes, helping industries maximize their government benefits.'
  },
  {
    name: 'Mr. Jeetesh Dutt Mathur',
    role: 'Marketing Vertical Head',
    image: IMAGES.jeetesh,
    linkedin: 'https://www.linkedin.com/in/jeetesh-mathur-3a6b4441/',
    description: 'A Commerce Graduate with over 15 years of experience in retail finance. His career includes 7 years as Sales Head at Citi Financial and 8 years as AVP at Andromeda. Jeetesh leads the Retail Loans sector, managing relationships across banks and NBFCs.'
  }
];

export const AboutLeadership = () => (
  <section className="py-24" data-testid="leadership-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Leadership
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Meet Our Team
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Experienced professionals committed to your financial success.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {leadership.map((leader, index) => (
          <motion.div
            key={leader.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Card className="h-full overflow-hidden border border-slate-100 hover:border-[#00bcd4]/30 transition-all group bg-white">
              <div className="relative h-72 overflow-hidden bg-gradient-to-br from-slate-100 to-slate-200">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-xl font-semibold text-white">{leader.name}</h3>
                  <p className="text-[#00bcd4] text-sm font-medium">{leader.role}</p>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-[#64748b] text-sm leading-relaxed mb-4">
                  {leader.description}
                </p>
                <a
                  href={leader.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#0077b5] text-sm font-medium hover:text-[#006097] transition-colors"
                >
                  <Linkedin size={16} />
                  Connect on LinkedIn
                </a>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/leadership"
          className="inline-flex items-center gap-2 text-[#3b5998] font-medium hover:text-[#00bcd4] transition-colors"
        >
          View Full Leadership Profiles →
        </Link>
      </div>
    </div>
  </section>
);
